import { createSelector } from 'reselect';

const selectDbaTypes = (state: any) => state.dbaTypes;


export const selectDbaTypesCurrentItem = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.current);

export const selectDbaTypesListItems = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbaTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbaTypesQueryItems = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.query);

export const selectDbaTypesCreatedItem = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.create);

export const selectDbaTypesUpdatedItem = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.update);

export const selectDbaTypesReadItem = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.read);

export const selectDbaTypesDeletedItem = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.delete);

export const selectDbaTypesSearchedItems = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.search);

export const selectDbaTypesItemsCount = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.count);

export const selectDbaTypesItemsFilter = createSelector([selectDbaTypes], (dbaTypes) => dbaTypes.filter);